<form [formGroup]="form" class="flex flex-col bg-white p-7 rounded-lg shadow-lg  mx-auto" *ngIf="visible">
  @if(step < 3) {
    <h2 class="text-3xl font-semibold text-gray-800 mb-6 text-center">Quanto è stato facile usare questo servizio?</h2>
    <div class="flex justify-center mb-8">
      <app-star-rating formControlName="rating"></app-star-rating>
    </div>
  }
  
  @if(form.get('rating')?.value && step == 1) {
    @if(form.get('rating')?.value < 4) {
      <label id="radio-group-label1" class="text-lg font-semibold mb-4 text-gray-700">Dove hai incontrato le maggiori difficoltà?</label>      
      <mat-radio-group formControlName="option" aria-labelledby="radio-group-label1" class="flex flex-col space-y-3 mb-6">
        @for (option of options1; track option) {
          <mat-radio-button class="example-radio-button" [color]="'primary'" [value]="option.value">
            <span class="text-lg font-medium text-gray-700">{{option.label}}</span>
          </mat-radio-button>
        }
      </mat-radio-group>
    }
    @else {
      <label id="radio-group-label2" class="text-lg font-semibold mb-4 text-gray-700">Quali sono stati gli aspetti che hai preferito?</label>
      <mat-radio-group formControlName="option" aria-labelledby="radio-group-label2" class="flex flex-col space-y-3 mb-6">
        @for (option of options2; track option) {
          <mat-radio-button class="example-radio-button" [color]="'primary'" [value]="option.value">
            <span class="text-lg font-medium text-gray-700">{{option.label}}</span>
          </mat-radio-button>
        }
      </mat-radio-group>
    }
  
    <div class="flex justify-center">
      <button (click)="onNext()" type="button" mat-button class="max-w-max px-8 py-2 rounded-md bg-primary hover:bg-primary-dark text-white font-semibold text-lg transition-colors duration-200" color="'primary'" [disabled]="!form.get('option')?.value">
        Avanti
      </button>
    </div>
  }
  
  @else if (step == 2) {
    <mat-form-field class="mb-6">
      <mat-label class="text-lg font-semibold text-gray-700">Vuoi aggiungere altri dettagli?</mat-label>
      <textarea matInput placeholder="Lascia un commento" formControlName="comment" class="min-h-[100px]"></textarea>
    </mat-form-field>
  
    <div class="flex justify-center">
      <button (click)="onNext()" type="button" mat-button class="max-w-max px-8 py-2 rounded-md bg-primary hover:bg-primary-dark text-white font-semibold text-lg transition-colors duration-200" color="'primary'">
        Avanti
      </button>
    </div>
  }
  
  @else if (step == 3) {
    <div class="text-center py-6">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 text-green-500 mx-auto mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
      <label class="text-2xl font-semibold text-gray-800">Grazie, il tuo parere ci aiuterà a migliorare il servizio!</label>
    </div>
  }
</form>